import { usePrices } from '@/configs/general.configs';
import * as types from '../mutation-types'
// import store from '..';

export default {
	namespaced: true,
	state: {
		materials: [],
		specialtyMaterials: []
	},

	actions: {
		fetchAll({ commit }, { name, materialFormId }) {
			return window.axios.get('/materials', {
				params: {
					name: name,
					materialFormId: materialFormId,
					withPrices: usePrices
				}
			})
				.then((response) => {
					commit(types.STORE_MATERIALS, response.data);
					return response.data
				})
		},

		fetchById({ commit }, { id }) {
			return window.axios.get(`/materials/${id}`).then((response) => {
				return response.data;
			})
		},

		fetchAllForSpecialtyVisits({ commit }, { fromDate, toDate, specialtyId, workloadId, query, team, entityId, planName }) {
			return window.axios.get('/materialPlan/mine', {
				params: { fromDate, toDate, specialtyId, workloadId, query, team, entityId, planName }
			}).then((response) => {
				commit(types.SPECIALTY_MATERIALS, response.data);
				return response.data;
			})
			// return window.axios.get('/materials/teams', {
			// 	params: {
			// 		employeeId: store.state.auth.self.employeeId,
			// 		fromDate,
			// 		toDate
			// 	}
			// }).then((response) => {
			// 	commit(types.SPECIALTY_MATERIALS, response.data);
			// 	return response.data;
			// })
		},

		reset({ commit }) {
			commit(types.RESET_MATERIALS);
		}
	},

	mutations: {
		[types.STORE_MATERIALS](state, materials) {
			state.materials = materials.sort(function(a, b) {
				if (a.name < b.name) {
					return -1
				};
				if (a.name > b.name) {
					return 1
				};
				return 0
			});
		},

		[types.SPECIALTY_MATERIALS](state, specialtyMaterials) {
			const items = [];

			// grouping materials by specialty then workload
			specialtyMaterials.forEach(e => {
				// specialty group
				let specialtyGroup = items.find(c => c.specialtyId === e.specialtyId);
				if (!specialtyGroup) {
					specialtyGroup = {
						specialtyId: e.specialtyId,
						specialtyName: e.specialtyName,
						workloads: [],
						materials: []
					};
					items.push(specialtyGroup);
				}

				if (e.workloadId) {
					// workload group
					let workloadGroup =
						specialtyGroup.workloads.find(c => c.workloadId === e.workloadId);
					if (!workloadGroup) {
						workloadGroup = {
							workloadId: e.workloadId,
							workloadName: e.workloadName,
							materials: []
						};
						specialtyGroup.workloads.push(workloadGroup);
					}
					workloadGroup.materials.push({
						materialId: e.materialId,
						materialName: e.materialName,
						amount: e.amount,
						coreMessage: e.coreMessage,
						id: e.id,
						planId: e.planId,
						planName: e.planName
					});
				} else {
					specialtyGroup.materials.push({
						materialId: e.materialId,
						materialName: e.materialName,
						amount: e.amount,
						coreMessage: e.coreMessage,
						id: e.id,
						planId: e.planId,
						planName: e.planName
					});
				}
			});

			state.specialtyMaterials = items;
		},

		[types.RESET_MATERIALS](state) {
			state.materials = [];
			state.specialtyMaterials = [];
		},
	},

	getters: {
		getMaterialById: state => id => state.materials.find(c => c.id === id),
		getMaterialByName: state => name => state.materials.find(c => c.name === name)
	}
}
